import React from 'react';
import {FormattedMessage} from 'react-intl';
import ButtonAction from '../../../../common/components/ui/ButtonAction';
import styles from './ButtonSubmit.module.scss';

const ButtonSubmit = () => {
  return (
      <ButtonAction
        variant={'button'}
        type={'submit'}
        label={(
          <FormattedMessage
            id={'inviteFriend-form-submitBtn'}
            defaultMessage={'Send'}
          />
        )}
        customClassnames={{container: styles.buttonContainer}}
      />
  );
};

export default ButtonSubmit;
